import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMailerState, ISendEmailRequest, ISendEmailResponse } from './types';

export const initialState: IMailerState = {
  loading: false,
  response: null,
};

const mailer = createSlice({
  name: '@@mailer',
  initialState,
  reducers: {
    sendEmailRequest: (state, _action: PayloadAction<ISendEmailRequest>) => {
      state.loading = true;
      state.response = null;
    },
    sendEmailSuccess: (state, action: PayloadAction<ISendEmailResponse>) => {
      state.loading = false;
      state.response = action.payload;
    },
    sendEmailFailure: (state) => {
      state.loading = false;
    },
    resetSendEmail: (state) => {
      state.loading = false;
      state.response = null;
    },
  },
});

export default mailer.reducer;
export const { sendEmailRequest, sendEmailSuccess, sendEmailFailure, resetSendEmail } =
  mailer.actions;
